import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Header, {
  getFirstFlg,
  getFixedFlg,
  getInitTenpoCode,
  setFirstFlg,
} from "../../Header/Header";
import TSCheckTab from "./TSCheckTab";
import { getTenpoFirestoreData } from "./TSCheckTableDataOperation";
import { Redirect } from "react-router-dom";
import { isFirebaseAuth } from "../../../firebase";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import {
  isOpenRegistPage,
  JOB_CATEGORY_CODE_DM,
  JOB_CATEGORY_CODE_ZM,
} from "../../../apis/privilege";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerRoot: {
      flexGrow: 1,
    },
    header: {
      flexGrow: 1,
    },
    headerToolbar: {
      // ヘッダーの縦の調整はminHeight を再設定する
      [theme.breakpoints.down("sm")]: {
        minHeight: "36px",
      },
      [theme.breakpoints.up("md")]: {
        minHeight: "48px",
      },
    },
    root: {
      height: "100vh",
    },
    gridMargin: {
      padding: "1%",
    },
  })
);

// 対象店舗衛生点検ID
let initTSCheckId: string = "";
let initLastTSCheckId: string = "";
/** データセット */
export function setTSCheckId(id: any) {
  initTSCheckId = id;
}
export function getTSCheckId() {
  return initTSCheckId;
}
/** データセット */
export function setLastTSCheckId(id: any) {
  initLastTSCheckId = id;
}
export function getLastTSCheckId() {
  return initLastTSCheckId;
}

const Home: React.FC = (props: any) => {
  const classes = useStyles();

  const [tenpoCode, setTenpoCode] = React.useState(getInitTenpoCode());
  const [tsCheckId, setTSCheckId] = React.useState("");
  const [lastTSCheckId, setLastTSCheckId] = React.useState("");
  const tenpoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setTenpoCode(event.target.value as string);
    setTSCheckId("");
    setLastTSCheckId("");
  };
  const [updateFlg, setUpdateFlg] = React.useState("");
  const user = useSelector(selectUser);

  useEffect(() => {}, []);
  useEffect(() => {
    if (tenpoCode === "" || getFirstFlg()) {
      setFirstFlg(false);
      setTenpoCode("");
      setTSCheckId("");
      setLastTSCheckId("");
      return;
    }
    if (initTSCheckId === "") {
      getTenpoFirestoreData(tenpoCode).then((res: any) => {
        if (user.jobCategoryCodeOA === JOB_CATEGORY_CODE_DM) {
          if (res.attribution.ts_check && res.attribution.ts_check.dm) {
            setTSCheckId(res.attribution.ts_check.dm.next_time_id);
            setLastTSCheckId(res.attribution.ts_check.dm.last_time_id);
          } else {
            setTSCheckId(tenpoCode + "-firstId-dm");
            setLastTSCheckId("");
          }
        } else if (user.jobCategoryCodeOA === JOB_CATEGORY_CODE_ZM) {
          if (res.attribution.ts_check && res.attribution.ts_check.zm) {
            setTSCheckId(res.attribution.ts_check.zm.next_time_id);
            setLastTSCheckId(res.attribution.ts_check.zm.last_time_id);
          } else {
            setTSCheckId(tenpoCode + "-firstId-zm");
            setLastTSCheckId("");
          }
        } else {
          if (res.attribution.ts_check && res.attribution.ts_check.ofc) {
            setTSCheckId(res.attribution.ts_check.ofc.next_time_id);
            setLastTSCheckId(res.attribution.ts_check.ofc.last_time_id);
          } else {
            setTSCheckId(tenpoCode + "-firstId");
            setLastTSCheckId("");
          }
        }
      });
    } else {
      setTSCheckId(initTSCheckId);
      setLastTSCheckId(initLastTSCheckId);
    }
    setFirstFlg(false);
  }, [tenpoCode, updateFlg, getFirstFlg()]);

  // 画面表示可否
  if (!isFirebaseAuth()) {
    return <></>;
  }
  if (
    (!isOpenRegistPage(user) && !getFixedFlg()) ||
    (tenpoCode === "" && getFixedFlg())
  ) {
    return <Redirect to="/home" />;
  }

  return (
    <Grid container className={classes.root} justify="center">
      <Grid item xs={12}>
        <Header
          titleName={"店舗衛生点検表"}
          tenpoChange={(e) => tenpoChange(e)}
        />
        <Grid item xs={12} className={classes.gridMargin}>
          {tenpoCode === "" ? (
            <Grid container justify="center">
              右上の店舗名より新規作成する店舗を選択してください。
            </Grid>
          ) : (
            <TSCheckTab
              tenpoCode={tenpoCode}
              tsCheckId={tsCheckId}
              lastTSCheckId={lastTSCheckId}
              setUpdateFlg={setUpdateFlg}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Home;
